import React from 'react';

import './index.sass';


const Facilities = ({ facilities }) => {

  return (
    <div className="facilities">
      <h2 className="detail-view__section-header">Faciliteter:</h2>

      <div className="facilities__list">
        { facilities.map(facility =>
          <div className="facilities__list-item" key={facility.key}>
            <img alt={facility.name}
                 className="lazyload"
                 data-src={facility.icon}
                 data-sizes="24"
                 data-expand="100"
                 height={24}
                 width={24}
            />
            { facility.name }
          </div>
        )}
      </div>
    </div>
  )
}

export default Facilities;
